import { TableDataWithImage } from '@spo/logic';
import { Cell, flexRender, Row } from '@tanstack/react-table';
import { VpCheckbox } from '@vtmn-play/react';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

export interface TableRowProps {
  rowIndex: number;
  row: Row<TableDataWithImage>;
  isRowSelected: boolean;
  selectedSmIds: string[];
  selectSmId: (smId: string) => void;
  onCellClick?: (smId: string, startDate: string, endDate: string) => void;
}

export const TableRow = ({
  rowIndex,
  row,
  isRowSelected,
  selectedSmIds,
  selectSmId,
  onCellClick,
}: TableRowProps) => {
  const [isRowChecked, setIsRowChecked] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsRowChecked(selectedSmIds?.includes(row?.original.id));
  }, [selectedSmIds, row]);

  return (
    <tr
      data-testid="table-row"
      className={clsx({
        'row--selected': isRowSelected,
        'row--checked': isRowChecked,
      })}
      key={row?.id}
      id={row?.original.id}
      style={{ height: '2.5rem' }}
    >
      <td data-testid="cell-checkbox">
        <VpCheckbox
          data-testid="select-sm-checkbox"
          id={`select-sm-checkbox-${row?.original.id}`}
          checked={isRowChecked}
          onChange={(event) => {
            selectSmId(row?.getVisibleCells()[0].getValue() as string);
            event && setIsRowChecked(event.currentTarget.checked);
          }}
        />
      </td>
      {row
        ?.getVisibleCells()
        .map((cell: Cell<TableDataWithImage, unknown>, columnIndex: number) => (
          <td
            key={cell.id}
            data-testid={`cell${rowIndex}-${columnIndex}`}
            role="gridcell"
            onClick={() =>
              onCellClick &&
              onCellClick(
                row?.original.id,
                row?.original.startDate,
                row?.original.endDate,
              )
            }
          >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </td>
        ))}
    </tr>
  );
};
